import { Tooltip } from '@/components/primitives/Tooltip'
import { FormControlLabel, Radio, RadioGroup } from '@mui/material'

import { ModalMode, type OrdersDistribution } from '../../../hooks/useController'

import { useTexts } from './useTexts'

type TargetRangeRadioProps = {
  mode: ModalMode
  value: uui.domain.ui.forms.TargetRange
  onChange: (value: uui.domain.ui.forms.TargetRange) => void
  ordersDistribution: OrdersDistribution
  selectedOrders: uui.domain.client.rm.ExtendedOrderStep[]
}

export function TargetRangeRadio(props: TargetRangeRadioProps) {
  const { value, onChange, mode, ordersDistribution, selectedOrders } = props

  const allTexts = useTexts()

  if (props.mode === 'empty') {
    return null
  }

  const texts = mode === 'bulk' ? allTexts.bulk : allTexts.single

  const hasMixedDistribution = ordersDistribution === 'mixed'
  const isFutureOptionDisabled =
    hasMixedDistribution || selectedOrders.every(order => order.order?.nextRecurrentOrder === null)

  return (
    <RadioGroup
      value={value}
      onChange={event => onChange(event.target.value as uui.domain.ui.forms.TargetRange)}
    >
      <FormControlLabel value="ORDER" control={<Radio />} label={texts.order} />
      <Tooltip
        title={
          hasMixedDistribution
            ? allTexts.disabledFutureTooltip
            : allTexts.disabledFutureTooltipForLastOccurrenceDelete
        }
        disabled={!isFutureOptionDisabled}
        placement="bottom"
      >
        <FormControlLabel
          value="FUTURE"
          control={<Radio disabled={isFutureOptionDisabled} />}
          label={texts.future}
        />
      </Tooltip>
      <FormControlLabel value="ALL" control={<Radio />} label={texts.all} />
    </RadioGroup>
  )
}
